<template>
	<div>
		<v-toolbar-title>
			<template v-if="title">
				<router-link to="/">{{rootTitle}}</router-link> /
				<template v-if="isAtlas">
					<router-link to="/my-content">Mano turinys</router-link> /
				</template>
				<template v-if="title == '{loading}'">
					<v-progress-circular
						indeterminate
						color="primary"
						:size="20"
						width="2"
					></v-progress-circular>
				</template>
				<template v-else>
					<template v-if="isAtlas && isAtlas.id">
						<router-link :to="'/atlas/' + isAtlas.id">{{title}}</router-link> / <span>{{getAtlasActionTitle(isAtlas.type)}}</span>
					</template>
					<template v-else>
						{{title}}
					</template>
				</template>
			</template>
			<template v-else>{{rootTitle}}</template>
		</v-toolbar-title>
	</div>
</template>

<script>
	export default {
		props: {
			title: String,
			isAtlas: Object
		},
		data: function(){
			var data = {
				rootTitle: "Geoportal.lt atlasai"
			};
			return data;
		},
		methods: {
			getAtlasActionTitle: function(type){
				var title = type;
				if (type == "edit") {
					title = "Redagavimas";
				} else if (type == "view") {
					title = "Peržiūra";
				}
				return title;
			}
		}
	};
</script>